<template>
  <div class="container-fluid overflow-auto">
    <bread-crumb :bread_crumb_data="view.bread_crumb_data"></bread-crumb>

    <b-tabs v-model="tab.tabIndex" class="mb-4">
      <b-tab
        v-for="(item, index) in tab.items"
        :key="index"
        :title="item.label" />
    </b-tabs>

    <div v-if="tab.tabIndex === 2" class="mb-2">
      <b-button variant="success" :disabled="selectNum < 2" @click="mergeBill()">合併帳單</b-button>
    </div>

    <tables-page
      :tableData="data.table_data"
      :tableFields="tableFields"
      :pageData="data.page"
      v-on:result="getPayList"
    >
      <template #cell(function)="row">
        <b-button
          variant="primary"
          size="sm"
          @click="billhandle(row.item, 'preview')"
          v-if="row.item.total_1 !== 0 && billDownloadConfig"
        >
          詳細帳單
        </b-button>

        <!-- <b-button
          variant="info"
          size="sm"
          @click="billhandle(row.item, 'download')"
          v-if="row.item.total_1 !== 0"
        >
          下載帳單
        </b-button> -->
      </template>

      <template #head(checkbox)>
        <b-form-checkbox v-model="status.isCheckboxAll" @change="toggleCheckboxAll"></b-form-checkbox>
      </template>

      <template #cell(checkbox)="row">
        <b-form-checkbox v-if="!row.item.order_create" v-model="row.item.checkbox"></b-form-checkbox>
      </template>

      <template #cell(no)="row">
        {{ countNoNum(data.page, row.index) }}
      </template>

      <template #cell(join_date)="row">
        {{ convertRocDate(row.item.join_date) }}
      </template>

      <template #cell(order_create)="row">
        <h4>
          <b-badge :variant="row.item.order_create ? 'warning': 'light'">{{ row.item.order_create ? '已合併': '未合併' }}</b-badge>
        </h4>
      </template>
    </tables-page>

    <html-to-pdf
      v-if="status.resetDom"
      ref="htmlToPdf"
      :isIframePreviewPdf="false"
      :enableDownload="status.pdfEnableDownload"
      @handlerCompleted="billhandlerCompleted"
      @exportImg="data.previewImg = $event"
    >
      <template slot="pdf-content">
          <print-template :data="data.temp_table_data"></print-template>
      </template>
    </html-to-pdf>

    <!-- 預覽帳單 modal -->
    <preview-bill-modal
      v-model="status.previewBillModal"
      :img="data.previewImg" />
  </div>
</template>

<script>
import BreadCrumb from '@/components/layouts/BreadCrumb';
import TablesPage from "@/components/layouts/TablesPage";
import toHelpingOthersApi from "@/models/API/toHelpingOthersApi";
import orderApi from "@/models/API/orderApi";
import { countNoNum, convertRocDate, getLocalUserInfo } from "@/models/HELPERS/common.js";
import HtmlToPdf from '@/components/common/HtmlToPdf';
import PrintTemplate from '@/components/common/PrintTemplate/Bill';
import PreviewBillModal from "@/components/common/Modal/PreviewBillModal";
import configApi from "@/models/API/configApi";

export default {
  name: 'pay',
  components: {
    BreadCrumb,
    TablesPage,
    HtmlToPdf,
    PrintTemplate,
    PreviewBillModal
  },
  data () {
    return {
      view: {
        bread_crumb_data: [
          { name: '繳費管理', url: '', isActive: true },
          { name: '繳費', url: '', isActive: false }
        ]
      },
      search: {
        number: '',
        name: '',
      },
      status: {
        resetDom: false,
        previewBillModal: false,
        pdfEnableDownload: false,
        isCheckboxAll: false
      },
      data: {
        table_data: [],
        page: {},
        temp_table_data: {},
        info: {},
        previewImg: '',
        billMode: ''
      },
      tab: {
        items: [
          {
            label: '全部',
            value: 0
          },
          {
            label: '已繳',
            value: 1
          },
          {
            label: '未繳',
            value: 2
          },
        ],
        tabIndex: 2
      },
      billDownloadConfig: 0
    }
  },
  watch: {
    'tab.tabIndex': {
      handler(newValue, oldValue) {
        this.getPayList();
      },
      immediate: false
    }
  },
  computed: {
    tableFields() {
      let table_fields = [
        {
          key: "no",
          label: "No",
        },
        {
          key: "number",
          label: "契約編號",
        },
        {
          key: "member_name",
          label: "互助人姓名",
        },
        {
          key: "join_date",
          label: "入會日期"
        },
        {
          key: "seniority_month",
          label: "年資(月)"
        },
        {
          key: "help_total",
          label: "已繳互助金"
        },
        {
          key: "total_1",
          label: "未繳金額"
        },
        {
          key: "pay_count",
          label: "繳費次數"
        },
        {
          key: "unpay_count",
          label: "未繳期數"
        },
        {
          key: "order_create",
          label: "合併狀態"
        },
      ]

      if (this.tab.tabIndex === 2) {
        table_fields.unshift(
          {
            key: "checkbox",
            label: "",
          },
          {
            key: "function",
            label: "列印"
          }
        )
      }

      return table_fields;
    },
    selectNum() {
      return this.data.table_data.filter((item) => item.checkbox).length;
    }
  },
  mounted() {
    this.toHelpingOthersApi = new toHelpingOthersApi();
    this.orderApi = new orderApi();
    this.configApi = new configApi();
    this.load();
  },
  methods: {
    // 首次載入讀取
    load() {
      this.data.page = Object.assign({}, this.toHelpingOthersApi.page);
      const meta = this.$route.meta;
      this.data.info = getLocalUserInfo(meta.authority);
      this.getPayList();
      this.getConfig();
    },
    countNoNum,
    convertRocDate,
    // 查詢繳費列表
    getPayList(pageIndex = null) {
      const params = {
        'class': this.classConversion(),
        'pay_ID_number': this.data.info.account,
        'PageSize': this.data.page.pageSize,
        'PageIndex': pageIndex ? pageIndex : this.data.page.pageIndex,
      };
      this.toHelpingOthersApi.getPayList((response) => {
        const res = response.data;

        this.data.page.totalCount = res.total; // 總筆數

        this.data.table_data = this.tab.tabIndex === 1 ? res.data.filter(item => item.total_1 === 0) : res.data;
      }, params)
    },
    // 類別換算
    classConversion() {
      switch(this.tab.tabIndex) {
        case 0:
          return '';
        case 1:
          return 0;
        case 2:
          return 1;
      }
    },
    // 帳單處理(下載 OR 預覽)
    async billhandle(item = null, type = 'download') {
      this.data.billMode = type;
      this.status.resetDom = true;
      this.data.temp_table_data = Object.assign({}, item);

      if (type === 'download') this.status.pdfEnableDownload = true;
      else if (type === 'preview') this.status.pdfEnableDownload = false;

      await this.$nextTick(); // 等待當前更新週期結束

      this.$refs.htmlToPdf.generatePdf();
    },
    // 帳單處理完成
    billhandlerCompleted() {
      this.$set(this.status, 'resetDom', false);
      this.$forceUpdate();

      if (this.data.billMode === 'preview') this.status.previewBillModal = true;
    },
    // 查詢環境設定
    getConfig() {
      this.configApi.getConfig((response) => {
        const res = response.data;

        this.billDownloadConfig = res.data[0].value;
      })
    },
    // 核取方塊 全選 || 取消全選 開關
    toggleCheckboxAll() {
      this.data.table_data.map(item => {
        if (!item.order_create) this.$set(item, 'checkbox', this.status.isCheckboxAll)
      });
    },
    mergeBill() {
      const selected_data = this.data.table_data.filter(item => item.checkbox);
      const r = confirm(`確定合併帳單(${selected_data.map(item => item.number).join(',')})？`);

      if (r) {
        const params = {
          member_id_arr: selected_data.map(item => item.id).join(',')
        };

        this.orderApi.addOrder((response) => {
          const res = response.data;
          let result = {};

          if (res.code === 0) {
            result = { message: '合併成功', title: '繳費' };

            this.status.isCheckboxAll = false;
            // this.getPayList();
            this.$router.push({
              name: 'ToHelpingOthersMergeBill',
              query: { openPreviewBillModalId: res.data.id }
            });
          } else {
            result = { message: '合併失敗', title: '繳費' };
          }

          this.orderApi.toast(() => {}, result, res.code === 0);
        }, params)

        return true;
      }
      return false;
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/Backstage/toHelpingOthers/pay.vue